import { Paper, Stack, Title, Button } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import useDeleteWorkspace from './useDeleteWorkspace';

const DeleteWorkspace = ( { workspaceID }: { workspaceID: number } ) => {
	const { onDeleteClicked } = useDeleteWorkspace( { workspaceID } );
	return (
		<Paper p={20} shadow="xs" style={{ background: 'var(--color-bg-container)' }}>
			<Stack spacing={20} justify="space-between" h="100%">
				<Stack spacing={14}>
					<Title order={4}>Delete Workspace</Title>
					<Text>
						Deleting the workspace will delete all projects and content.
						You won’t be able to recover it later.
					</Text>
				</Stack>
				<Stack align="end">
					<Button onClick={onDeleteClicked}>
						Delete Workspace
					</Button>
				</Stack>
			</Stack>
		</Paper>
	);
};

export default DeleteWorkspace;
